import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {
  getLabels(): DocumentNode {
    return gql`
      query getLabels ($where: LabelWhereInput, $offset: Int) {
        labels (where: $where, orderBy: { column: name, direction: asc }, limit: 50, offset: $offset) {
          items {
            id
            name
            color
          }
        }
      }
    `;
  }
}
